class GeoredirectPopup extends HTMLElement {
    constructor() {
        super();
        this.popup = this.querySelector('.popup-wraper-js');
        this.usButton = this.querySelector('.button-us-hide-js');
        this.nzButton = this.querySelector('.button-nz-hide-js');
        // this.stayButton = this.querySelector('.close-popup-js');
        this.events()
		this.showPopup();
        // this.checkCookie();

    }

    closePopup() {
        this.popup.classList.remove('show-popup-js');
		document.body.classList.remove('scroll--off');
    }
    showPopup(){
        async function load() {
            let url = 'https://www.bnhealthy.com.au/browsing_context_suggestions.json';
            let data = await (await fetch(url)).json();
          console.log('hi');
            let countryHendle = data.detected_values.country.handle;
            let popup = document.querySelector('.popup-wraper-js');
            let usButton = document.querySelector('.button-us-hide-js');
            let nzButton = document.querySelector('.button-nz-hide-js');
            function showPopup() {
                popup.classList.add('show-popup-js');
				document.body.classList.add('scroll--off');
            }
            if (location.hash.startsWith('#test_mode')){
                localStorage.setItem('testMode', 'true');
            }

            if (countryHendle == "AU" || localStorage.getItem('testMode') === 'true'){
               return false;
            }

            if (countryHendle == "US"){
                usButton.classList.remove('button-us-hide-js');
                showPopup();
                return false;
             }

             if (countryHendle == "NZ-"){
                nzButton.classList.remove('button-nz-hide-js');
                showPopup();
                return false;
             }

        }
        load();
    }
    setCookie(cname,cvalue,exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        let expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }
    getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i < ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "";
    }
    checkCookie(){
        let user = this.getCookie("UserHi");
        if (user == "") {
           user = "UserHi";
           if (user != "" && user != null) {
             // this.setCookie("UserHi", user, 30);
             this.showPopup();
           }
        }
    }
    deleteCookie(user) {
        this.setCookie(user, "", null , null , null, 1);
    }
    events(){
        this.addEventListener('click', (event) => {
            event.preventDefault();
            let target = event.target;
            // if (target.closest('.close-popup-icon-js') || target == this.popup  || target == this.stayButton){
            //     this.closePopup();
            // };
            if(target == this.usButton || target == this.nzButton){
                this.deleteCookie('UserHi')
				let redirectHref = target.getAttribute('href');
				if (redirectHref) {
					window.location.replace(redirectHref);
				}
				else  {
					this.closePopup();
				}

            }
        });
    }

  }

  customElements.define('georedirect-popup', GeoredirectPopup);
